import { render, staticRenderFns } from "./TeacherRegistration.vue?vue&type=template&id=317a5327&"
import script from "./TeacherRegistration.vue?vue&type=script&lang=js&"
export * from "./TeacherRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports